// extracted by mini-css-extract-plugin
export var carrierIcon = "_tu-0";
export var carrierLogo = "_tu-1";
export var detailsSection = "_tu-2";